import { useId } from "react";
import { TIMESHEET_STATUS_LABELS } from "../../api";
import type { TimesheetStatus } from "../../api";
import { cx } from "../../components";
import styles from "./Feuilles.module.css";

/** Un statut, ou « toutes ». */
export type StatutFiltre = TimesheetStatus | "toutes";

const STATUTS: TimesheetStatus[] = ["submitted", "rejected", "approved", "draft"];

export type FeuillesFiltresProps = {
  valeur: StatutFiltre;
  onChange: (valeur: StatutFiltre) => void;
};

/**
 * Filtre par statut. Contrairement à l'historique, il est appliqué **côté
 * serveur** : la liste est relue à chaque changement, et ce qu'on voit est
 * exhaustif. Des radios pour la même raison qu'ailleurs : exclusives, au
 * clavier, annoncées comme un groupe.
 */
export function FeuillesFiltres({ valeur, onChange }: FeuillesFiltresProps) {
  const nom = useId();
  const options: { cle: StatutFiltre; libelle: string }[] = [
    { cle: "submitted", libelle: "À valider" },
    ...STATUTS.filter((s) => s !== "submitted").map((s) => ({ cle: s as StatutFiltre, libelle: TIMESHEET_STATUS_LABELS[s] })),
    { cle: "toutes", libelle: "Toutes" },
  ];
  return (
    <fieldset className={styles.filtres}>
      <legend className={styles.legende}>Statut</legend>
      <div className={styles.choix}>
        {options.map((o) => (
          <label key={o.cle} className={cx(styles.puce, valeur === o.cle && styles.puceActive)}>
            <input
              type="radio"
              name={nom}
              value={o.cle}
              checked={valeur === o.cle}
              onChange={() => onChange(o.cle)}
              className="lde-visually-hidden"
            />
            <span>{o.libelle}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
